/* ============================================================
   ROYAL INTERNATIONAL 2026 — Animations & Interactions
   Particles · Scroll Reveal · Brand Marquee Filter
   ============================================================ */

(function() {
  'use strict';

  /* ── PARTICLES (hero canvas) ─────────────────────────────── */
  function initParticles() {
    const hero = document.querySelector('.hero, [class*="hero"]');
    if (!hero) return;

    const canvas = document.createElement('canvas');
    canvas.id = 'royal-particles';
    canvas.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:1;opacity:0.55';
    hero.style.position = hero.style.position || 'relative';
    hero.insertBefore(canvas, hero.firstChild);

    const ctx = canvas.getContext('2d');
    let W, H, pts;

    function resize() {
      W = canvas.width  = hero.offsetWidth;
      H = canvas.height = hero.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function make() {
      pts = Array.from({ length: 50 }, () => ({
        x:  Math.random() * W,
        y:  Math.random() * H,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        r:  Math.random() * 1.3 + 0.3,
        o:  Math.random() * 0.4 + 0.08
      }));
    }
    make();

    function draw() {
      ctx.clearRect(0, 0, W, H);
      pts.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = W;
        if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H;
        if (p.y > H) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201,168,76,${p.o})`;
        ctx.fill();
      });
      for (let i = 0; i < pts.length; i++) {
        for (let j = i + 1; j < pts.length; j++) {
          const dx = pts[i].x - pts[j].x;
          const dy = pts[i].y - pts[j].y;
          const d  = Math.sqrt(dx * dx + dy * dy);
          if (d < 120) {
            ctx.beginPath();
            ctx.moveTo(pts[i].x, pts[i].y);
            ctx.lineTo(pts[j].x, pts[j].y);
            ctx.strokeStyle = `rgba(201,168,76,${0.055 * (1 - d / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(draw);
    }
    draw();
  }

  /* ── SCROLL REVEAL ───────────────────────────────────────── */
  function initReveal() {
    if (!window.IntersectionObserver) return;

    const selectors = [
      '.product-card','.resource-card','.product-card-wrapper',
      '.card','.grid__item',
      '[class*="ai_gen_block"] > *',
      '.why-card','.city-card','.t-card',
      '.faq-item'
    ].join(',');

    const els = document.querySelectorAll(selectors);
    if (!els.length) return;

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          e.target.style.transition = `opacity 0.55s ease ${(i % 4) * 0.08}s, transform 0.55s ease ${(i % 4) * 0.08}s`;
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -30px 0px' });

    els.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      obs.observe(el);
    });
  }

  /* ── COUNTER ANIMATION ───────────────────────────────────── */
  function animateNum(el) {
    const target = parseFloat(el.dataset.royalTarget || el.textContent.replace(/[^0-9.]/g, ''));
    if (!target || isNaN(target)) return;
    const dur  = 1600;
    const t0   = performance.now();
    const orig = el.textContent;
    const isInt = Number.isInteger(target);
    function step(now) {
      const p  = Math.min((now - t0) / dur, 1);
      const e  = 1 - Math.pow(1 - p, 3);
      el.textContent = isInt ? Math.round(target * e) : (target * e).toFixed(1);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    if (!window.IntersectionObserver) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.querySelectorAll('[data-royal-target], .h-stat-n, .w-num').forEach(animateNum);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.why, .hero-stats, .h-stat').forEach(el => obs.observe(el));
  }

  /* ── NAV GLASS ON SCROLL ─────────────────────────────────── */
  function initNavScroll() {
    const nav = document.querySelector('nav, #nav, header-component, .header-section');
    if (!nav) return;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        // Already handled by royal-luxury.css sticky glass effect
        ticking = false;
      });
    });
  }

  /* ── BRAND MARQUEE FILTER ────────────────────────────────── */
  function initBrandMarquee() {
    const mqSection = document.getElementById('royal-brand-marquee');
    if (!mqSection) return;

    const activeLabel = document.getElementById('royal-mq-active-label');
    const buttons = mqSection.querySelectorAll('.royal-mq-item');

    // Map brand slug → possible filter pill text variants
    const brandMap = {
      'ferrari':      ['Ferrari'],
      'lamborghini':  ['Lamborghini'],
      'mclaren':      ['McLaren'],
      'rolls-royce':  ['Rolls Royce', 'Rolls-Royce', 'Rolls'],
      'porsche':      ['Porsche'],
      'mercedes':     ['Mercedes', 'Mercedes-Benz', 'Mercedes Benz'],
      'bmw':          ['BMW'],
      'audi':         ['Audi'],
      'corvette':     ['Corvette'],
      'cadillac':     ['Cadillac']
    };

    function findAndClickFilter(brandSlug) {
      const variants = brandMap[brandSlug] || [];

      // Strategy 1: find brand filter pill inside the fleet section
      // The AI block renders pills/buttons — look for any button/pill containing the brand text
      const allPills = document.querySelectorAll(
        '[class*="pill"], [class*="filter"], [class*="brand"] button, ' +
        '.filter-btn, button[data-brand], [class*="tag"]'
      );

      for (const pill of allPills) {
        const t = pill.textContent.trim();
        for (const v of variants) {
          if (t.toLowerCase() === v.toLowerCase() || t.toLowerCase().includes(v.toLowerCase())) {
            pill.click();
            return true;
          }
        }
      }

      // Strategy 2: look inside AI-generated collection blocks
      const aiBlocks = document.querySelectorAll(
        '[class*="ai_gen_block"], [class*="ai-gen"], [class*="collection-filter"]'
      );
      for (const block of aiBlocks) {
        const btns = block.querySelectorAll('button, [role="button"], .pill, .tag');
        for (const btn of btns) {
          const t = btn.textContent.trim();
          for (const v of variants) {
            if (t.toLowerCase().includes(v.toLowerCase())) {
              btn.click();
              return true;
            }
          }
        }
      }

      // Strategy 3: link to collection with vendor filter
      const collectionUrl = `/collections/exotic-car-fleet-orlando?filter.p.vendor=${encodeURIComponent(variants[0] || brandSlug)}`;
      window.location.href = collectionUrl;
      return false;
    }

    function handleBrandClick(e) {
      const btn = e.currentTarget;
      const brand = btn.dataset.brand;
      const brandName = btn.querySelector('span:last-child').textContent;

      // Toggle — if already active, show all
      const isActive = btn.classList.contains('active');

      // Reset all active states
      buttons.forEach(b => b.classList.remove('active'));

      if (isActive) {
        // De-select → show all
        if (activeLabel) activeLabel.textContent = '';
        // Try to click "All" filter
        document.querySelectorAll('button, [role="button"]').forEach(b => {
          if (/^all$/i.test(b.textContent.trim())) b.click();
        });
        // Scroll to fleet
        scrollToFleet();
        return;
      }

      // Mark active (first 10 = first loop only)
      const firstSetBtns = mqSection.querySelectorAll('.royal-mq-item[aria-hidden!=true]');
      firstSetBtns.forEach(b => {
        if (b.dataset.brand === brand) b.classList.add('active');
      });

      if (activeLabel) {
        activeLabel.textContent = `Showing: ${brandName.trim()}`;
      }

      scrollToFleet();

      // Small delay to let scroll start then trigger filter
      setTimeout(() => findAndClickFilter(brand), 350);
    }

    // Only attach to first set of items (not duplicates for loop)
    const firstSet = mqSection.querySelectorAll('.royal-mq-item:not([aria-hidden="true"])');
    firstSet.forEach(btn => btn.addEventListener('click', handleBrandClick));

    function scrollToFleet() {
      // Find fleet section — try several selectors
      const fleet =
        document.getElementById('fleet') ||
        document.querySelector('[class*="collection"], [class*="fleet"], [class*="product-grid"]');
      if (fleet) {
        const offset = 80;
        const top = fleet.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  }

  /* ── HERO GRID OVERLAY ───────────────────────────────────── */
  function initHeroGrid() {
    const hero = document.querySelector('.hero, section[class*="hero"]');
    if (!hero) return;
    if (document.getElementById('royal-hero-grid')) return;
    const grid = document.createElement('div');
    grid.id = 'royal-hero-grid';
    grid.style.cssText = `
      position:absolute;inset:0;pointer-events:none;z-index:1;
      background-image:
        linear-gradient(rgba(201,168,76,0.032) 1px, transparent 1px),
        linear-gradient(90deg, rgba(201,168,76,0.032) 1px, transparent 1px);
      background-size:90px 90px;
      -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 80%);
      mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 80%);
    `;
    hero.style.position = hero.style.position || 'relative';
    hero.insertBefore(grid, hero.firstChild);
  }

  /* ── WHATSAPP FLOAT PULSE ────────────────────────────────── */
  function initWAFloat() {
    // Already handled via royal-luxury.css .wa-float styles
    // Just ensure the element exists and is styled
    const wa = document.querySelector('.wa-float, [class*="whatsapp-float"]');
    if (wa && !wa.querySelector('.wa-pulse')) {
      const pulse = document.createElement('div');
      pulse.className = 'wa-pulse';
      pulse.style.cssText = 'position:absolute;inset:-5px;border-radius:50%;background:rgba(37,211,102,.22);animation:wap 2.2s ease-out infinite;pointer-events:none';
      wa.style.position = 'relative';
      wa.appendChild(pulse);
    }
  }

  /* ── SMOOTH NAV ACTIVE LINK ──────────────────────────────── */
  function initActiveNav() {
    const links = document.querySelectorAll('nav a, .nav-links a, .header__nav-item a, .menu-list__link');
    const sections = document.querySelectorAll('section[id]');
    if (!sections.length || !links.length) return;

    window.addEventListener('scroll', () => {
      let cur = '';
      sections.forEach(s => {
        if (window.scrollY >= s.offsetTop - 120) cur = s.id;
      });
      links.forEach(a => {
        const href = a.getAttribute('href') || '';
        if (href === '#' + cur) {
          a.style.color = '#c9a84c';
        } else if (href.startsWith('#')) {
          a.style.color = '';
        }
      });
    }, { passive: true });
  }

  /* ── INIT ALL ────────────────────────────────────────────── */
  function init() {
    initHeroGrid();
    initParticles();
    initReveal();
    initCounters();
    initBrandMarquee();
    initActiveNav();
    initWAFloat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run reveal after Shopify dynamic content loads
  document.addEventListener('shopify:section:load', () => setTimeout(initReveal, 200));

})();
